export const containerStyles = {
    position: 'relative'
};

export const inputStyles = {
    width: '100%'
};

export const buttonStyles = {
    position: 'absolute',
    top: '50%',
    right: '6px',
    marginTop: '-13px',
    padding: '4px 10px',
    background: '#e2e2e2',
    borderRadius: '2px',
    color: '#000',
    textAlign: 'center',
    textDecoration: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    userSelect: 'none'
};
